import { IRecordingsPopupFilter } from './recordings-popup.model';

export const WINDOW_CHANNEL_NAME = 'lytehouse-windows';

export const WINDOW_CHANNEL_MESSAGE_TYPES = {
    RECORDINGS_POPUP_READY: 'recordings-popup/ready',
    RECORDINGS_POPUP_FILTER: 'recordings-popup/filter',
    AUTH_SIGNED_OUT: 'auth/signed-out',
} as const;

// Every message names its sender; `to` addresses a single window; omitted means every window.
export interface IWindowChannelEnvelope {
    from: string;
    to?: string;
}

export interface IRecordingsPopupReadyMessage extends IWindowChannelEnvelope {
    type: typeof WINDOW_CHANNEL_MESSAGE_TYPES.RECORDINGS_POPUP_READY;
}

export interface IRecordingsPopupFilterMessage extends IWindowChannelEnvelope {
    type: typeof WINDOW_CHANNEL_MESSAGE_TYPES.RECORDINGS_POPUP_FILTER;
    payload: IRecordingsPopupFilter;
}

export interface IAuthSignedOutMessage extends IWindowChannelEnvelope {
    type: typeof WINDOW_CHANNEL_MESSAGE_TYPES.AUTH_SIGNED_OUT;
    // Identifies the sign-in session that ended, so a delayed message can't end a later one.
    payload: { sessionId: string };
}

export type WindowChannelMessage =
    | IRecordingsPopupReadyMessage
    | IRecordingsPopupFilterMessage
    | IAuthSignedOutMessage;

export type WindowChannelMessageType = WindowChannelMessage['type'];

type DistributiveOmit<T, K extends PropertyKey> = T extends unknown ? Omit<T, K> : never;

// The sender is stamped by WindowChannelService, so callers post messages without `from`.
export type OutgoingWindowChannelMessage = DistributiveOmit<WindowChannelMessage, 'from'>;
